export default defineNuxtPlugin(async () => {
  const basket = useStoreBasket()

  watch(basket.purchases, () => {
    basket.updateBasketInSession()
  })
})
